<template>
  <div>
    <Lockscreen />
  </div>
</template>
<script>
import Lockscreen from "@/components/system/Auth/Lockscreen";
export default {
  components: {
    Lockscreen,
  },
};
</script>
